import React, { useState } from 'react';
import { PageContentLayout, PageHeaderLayout } from '../../../shared/layout';
import { TagsOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import DetailsCard from './components/DetailsCard';
import GeneratedTagsCard from './components/GeneratedTagsCard';
import DisableEnableTagModal from './components/DisableEnableTagModal';
import SignUpsCard from './components/SignUpsCard';
import TestLogsCard from './components/TestLogsCard';
// import RegenerateTag from './components/RegenarateTag'; // Commented out per new requirements
import { withRouter, useLocation } from 'react-router-dom';
import '../styles/index.scss';

const TagsDetailsView = ({
  details,
  generatedTag,
  signUpsTag,
  testTag,
  testLogs,
  basicTagActivityData,
  tagActivityLoading,
  regenerateTag,
  userPermission,
  carts,
  history,
  dsps,
  onDisableEnableTag,
}) => {
  const { isTrafficker } = userPermission;
  const [retailIds, setRetailIds] = useState([""]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const source = searchParams.get('source');

  let type = 'measurement';

  switch (source) {
    case 'impression':
      type = 'impression';
      break;
    case 'publisher':
      type = 'publisher';
      break;
    default:
      type = 'measurement';
      break;
  }
  if (details.isPublisherDomain) type = 'publisher';
  else if (details.isAdvertiser) type = 'impression';

  return (
    <div className="tags-page">
      <div className="tags-details__page-header">
      <PageHeaderLayout
        title={details.name}
        titleIcon={<TagsOutlined />}
        rightContent={
          <Row gutter={[16, 16]}>
            <Col>
              {/* Regenerate Tag button commented out per new requirements */}
              {/* {isTrafficker ? (
                <RegenerateTag
                  cart={details.cart}
                  environment={
                    details.impressionEnvironments ? details.impressionEnvironments : details.dsp
                  }
                  regenerateTag={regenerateTag}
                  domain={details.domain}
                  carts={carts}
                  dsps={dsps}
                  type={type}
                  appId={details.appId}
                />
              ) : null} */}
            </Col>
            <Col>
              {isTrafficker ? (
                <Button
                  type="primary"
                  shape="round"
                  onClick={() => {
                    history.push(`/tags/manager/${details.id}?source=${source}`);
                  }}
                >
                  Update Tag
                </Button>
              ) : null}
            </Col>
            <Col>
              {isTrafficker ? (
                <DisableEnableTagModal
                  onDisableEnableTag={onDisableEnableTag}
                  disabled={details.isDisabled}
                />
              ) : null}
            </Col>
          </Row>
        }
      />
      </div>
      <PageContentLayout>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={12}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <DetailsCard details={details} type={type} retailIds={retailIds} setRetailIds={setRetailIds} testTag={testTag} />
              </Col>
              <Col span={24}>
                <TestLogsCard
                  logs={testLogs}
                  hasBasketItems={generatedTag.basketItems > 0}
                  hasSignups={signUpsTag.signups > 0}
                  testTag={testTag}
                  loading={tagActivityLoading}
                  type={type}
                  retailIds={retailIds}
                  basicTagActivityData={basicTagActivityData}
                  generatedTag={generatedTag}
                  details={details}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={24} xl={12}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <GeneratedTagsCard
                  generatedTag={generatedTag}
                  details={details}
                />
              </Col>
              {signUpsTag && (signUpsTag.signups > 0 || signUpsTag.hasSignups) && (
                <Col span={24}>
                  <SignUpsCard signUpsTag={signUpsTag} generatedTag={generatedTag} />
                </Col>
              )}
            </Row>
          </Col>
        </Row>
      </PageContentLayout>
    </div>
  );
};

export default withRouter(TagsDetailsView);
